import { useRequiredContext } from "@redotech/react-util/context";
import VerifiedCheckIcon from "@redotech/redo-icons/check-verified-02.svg";
import VerifiedCheckFilledIcon from "@redotech/redo-icons/check-verified-02_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const ClassifyProductsItem = memo(function ClassifyProductsItem() {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER,
    OrderManagementPermissions.VIEW_RETURN,
    OrderManagementPermissions.MANAGE_WARRANTY,
    OrderManagementPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
    OrderManagementPermissions.MANAGE_SHIPMENTS,
  );

  if (!team.settings.classifyProductsEnabled || !hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.classifyProductsHref }}
      FilledIcon={VerifiedCheckFilledIcon}
      friendlyName="Classify Products"
      id="classify-products"
      UnfilledIcon={VerifiedCheckIcon}
    />
  );
});
